import React, { useState, useEffect } from 'react';
import styles from './TemplateHero2.module.css';

const TemplateHero2 = ({ branding, heroData }) => {
  const [currentSlide, setCurrentSlide] = useState(0);

  // Safely extract slides with no hardcoded fallbacks
  const slides = heroData?.slides || [];

  // Auto-play slider logic
  useEffect(() => {
    if (slides.length <= 1) return;

    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000); 

    return () => clearInterval(interval);
  }, [slides.length]);

  // Hide component safely if no data is present
  if (slides.length === 0) return null;

  return (
    <div className={styles.heroContainer}>
      
      {/* Background Slides */}
      {slides.map((slide, index) => (
        <div
          key={index}
          className={`${styles.slide} ${index === currentSlide ? styles.activeSlide : ''}`}
          style={{ backgroundImage: `url('${slide.image}')` }}
        >
          {/* Gradient overlay: Dark on left for text readability, clear on right for image visibility */}
          <div className={styles.gradientOverlay}></div>
        </div>
      ))}

      {/* Content Container (Left Aligned) */}
      <div className={styles.container}>
        <div className={styles.contentWrapper}>
          
          {/* The Glassmorphism Card */}
          <div className={styles.glassCard} key={`card-${currentSlide}`}>
            <span className={styles.badge}>Featured Tour</span>
            <h1 className={styles.title}>{slides[currentSlide].title}</h1>
            <p className={styles.subtitle}>{slides[currentSlide].subtitle}</p>
            
            <div className={styles.buttonGroup}>
              <button className={`btn btn-primary btn-lg ${styles.primaryBtn}`}>
                Book Now
              </button>
              <button className={`btn btn-light btn-lg ${styles.secondaryBtn}`}>
                Discover
              </button>
            </div>
          </div>

        </div>
      </div>

      {/* Vertical Slider Indicators (Dots on the right side) */}
      {slides.length > 1 && (
        <div className={styles.verticalIndicators}>
          {slides.map((_, index) => (
            <span
              key={index}
              onClick={() => setCurrentSlide(index)}
              className={`${styles.dot} ${index === currentSlide ? styles.activeDot : ''}`}
            ></span>
          ))}
        </div>
      )}
      
    </div>
  );
};

export default TemplateHero2;